const checkCellError = () => {};

const disabledFields = {
  product: ["sku"],
};

export { disabledFields };
